import React, { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { SuperSEO } from "react-super-seo";

import { Breadcrumb, Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import { Link, NavLink } from "react-router-dom";
import { DB_POSTFIX, groupByMultiple, makeUrl, upperCase } from "../../utils";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import PageContent from "../programmes/department/pageContent";
import CourseList from "../programmes/department/courseList";
import SyllabusList from "../programmes/department/syllabusList";
import FaulctyList from "../programmes/department/faulctyList";

const DepartmentLayout = (props) => {
  const context = useContext(PsContext);

  const [departmentData, setDepartmentData] = useState([]);
  const [dept, setDept] = useState([]);
  const [loader, setLoader] = useState(false);

  const [hashPath, setHashPath] = useState("");

  useEffect(() => {
    loadData();
  }, [JSON.stringify(props.match)]);

  useEffect(() => {
    if (props.location.hash) setHashPath(props.location.hash);
    else setHashPath("#about");
  }, [props.location.hash]);

  const loadData = () => {
    setLoader(true);
    setDepartmentData([]);
    const form = new FormData();
    //form.append("id", props.match.params.id);
    let id = props.match.params.id;
    axios.post(ServiceUrl.DEPARTMENTS + "?sadb=" + DB_POSTFIX).then((res) => {
      if (res["data"].status == "1") {
        let m = res["data"].data.find((item) => item.id == id);
        setDepartmentData(res["data"].data);
        setDept(m);
      }
      setLoader(false);
    });
  };

  const getDepartments = () => {
    let m = groupByMultiple(departmentData, function (obj) {
      return [obj.dept_type];
    });
    return m;
  };

  const deptLink = (items) => {
    return items.map((item) => (
      <li style={{ padding: "10px 0px" }}>
        <i className="fa-solid fa-chevron-right me-2 "></i>
        <NavLink
          to={`/department/${item.id}/${makeUrl(item.department)}`}
          activeClassName="text-danger"
          className="fs-14 "
        >
          {item.department}
        </NavLink>
      </li>
    ));
  };

  const shortMenus = [
    { title: "About", path: "#about" },
    { title: "Vision & Mission", path: "#vision_mission" },
    { title: "Courses Offered", path: "#courses" },
    { title: "Faculty", path: "#faculty" },
    { title: "Program Details", path: "#activities" },
    /*     { title: "Syllabus", path: "#syllabus" },    
    { title: "Awards", path: "#awards" },
    { title: "Placements", path: "#placements" },
    { title: "Funded Projects", path: "#fundedprojects" },
    { title: "Research Guides", path: "#researchguide" },
    { title: "University Ranks", path: "#universityranks" }, */
  ];

  const hashActiveClass = (item) => {
    return hashPath == item ? "text-danger" : "";
  };

  return (
    <>
      <section
        className="page-hero d-flex align-items-center"
        style={{
          backgroundImage:
            "url('https://portal.aei.edu.in//files_list/aei/drsacoe/fm/website/bredcrumbs/Campus_View2lwdf.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "220px",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        ></div>

        <div className="container position-relative text-white">
          <Breadcrumb>
            <Breadcrumb.Item href="/" className="text-light">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/departments" active className="text-light">
              Departments
            </Breadcrumb.Item>
          </Breadcrumb>
          <h2 className="fw-bold mb-0">{dept.department}</h2>
        </div>
      </section>
      <section>
        <div className="container-fluid com-sp pad-bot-70 pg-inn ps_min_height">
          <SuperSEO
            title={`Department of ${dept?.department}`}
            description={`Department of ${dept?.department}`}
            lang="en"
          />

          <Row>
            <Col md={3}>
              <div className="de-left-tit pt-2 pb-1">
                <h4 className="fs-14">Menu</h4>
              </div>
              <div className="ho-event">
                <ul className="ps__sidebar__links ps-0">
                  {shortMenus.map((item, i) => {
                    return (
                      <li>
                        <i className="fa-solid fa-chevron-right "></i>
                        <NavLink
                          to={item.path}
                          className="fs-14"
                          activeClassName={hashActiveClass(item.path)}
                        >
                          {item.title}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Col>
            <Col md={6}>
              <div className="shadow-sm p-3" style={{ overflowX: "auto" }}>
                <PageContent
                  pageId={hashPath}
                  withSlider={hashPath == "#about" ? true : false}
                  {...props}
                />
                {hashPath == "#courses" && <CourseList {...props} />}
                {hashPath == "#syllabus" && <SyllabusList {...props} />}
                {hashPath == "#faculty" && <FaulctyList {...props} />}
              </div>
            </Col>
            <Col md={3}>
              <div className="de-left-tit ">
                <h4 className="fs-14">Departments</h4>
              </div>
              <div className="ho-event">
                <ul className="ps__sidebar__links ps-0">
                  {getDepartments().map((item, i) => {
                    return (
                      <>
                        <div className="fs-14 py-2 text-center fw-bold">
                          {upperCase(item[0].dept_type)}
                        </div>
                        {deptLink(item)}
                      </>
                    );
                  })}
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default DepartmentLayout;
